var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import StoryBody from "../StoryBody";
import styles from "./PrimaryImage.css";

// Import the lazyloading module if the window context is defined.
if (typeof window !== "undefined") {
  import("lazysizes");
}

var PrimaryImage = function (_Component) {
  _inherits(PrimaryImage, _Component);

  function PrimaryImage() {
    _classCallCheck(this, PrimaryImage);

    return _possibleConstructorReturn(this, (PrimaryImage.__proto__ || Object.getPrototypeOf(PrimaryImage)).apply(this, arguments));
  }

  _createClass(PrimaryImage, [{
    key: "render",
    value: function render() {
      var image = this.props.image;


      if (!image || !Object.keys(image).length) {
        return null;
      } // APIs are inconsistent between null and empty object

      // Handle entity maps, add "caption" type
      var captionBlocks = image.caption && image.caption.blocks && _extends({}, image.caption, {
        blocks: image.caption.blocks.map(function (block) {
          return _extends({}, block, { type: "caption" });
        })
      });

      return React.createElement(
        "figure",
        null,
        React.createElement(
          "div",
          { className: styles.imageWrapper },
          React.createElement(
            "div",
            { className: styles.placeholder },
            this.props.lazyload ? React.createElement("img", { className: classNames(styles.img, "lazyload"), "data-src": image.crops["16x9"].url, alt: image.alt_text }) : React.createElement("img", { className: styles.img, src: image.crops["16x9"].url, alt: image.alt_text })
          )
        ),
        captionBlocks && React.createElement(
          "figcaption",
          { className: styles.caption },
          React.createElement(StoryBody, { story: { blocks: captionBlocks } })
        )
      );
    }
  }]);

  return PrimaryImage;
}(Component);

PrimaryImage.defaultProps = {
  lazyload: true
};

PrimaryImage.propTypes = {
  lazyload: PropTypes.bool,
  image: PropTypes.shape({
    alt_text: PropTypes.string,
    crops: PropTypes.shape({
      "16x9": PropTypes.shape({
        url: PropTypes.string
      })
    })
  })
};

export default PrimaryImage;


// WEBPACK FOOTER //
// ./src/components/Library/PrimaryImage/PrimaryImage.js